// src/@/lib/testIds.constant.ts

export const TEST_IDS_ADMIN_COMPONENT = {
  MOBILE_COUNTRY_CODE_BUTTON: "mobile-country-code-button",
};
